import styled from 'styled-components'

const Option = styled.button`
  background-color: white;
  border: solid 1px
    ${props => (props.isSelected ? props.theme.colors.primary : 'white')};
  ${props => (props.isMobile ? 'width: auto;' : 'width: 220px;')}
  text-overflow: ellipsis;
  ${'' /* white-space: nowrap; */}
  margin: ${props => (props.isMobile ? '10px 10px 0 0' : '20px 20px 0 0')};
  outline: none;
  padding: 13px 12px;
  opacity: ${props => (props.isSelected ? 1 : props.hasValue ? 0.6 : 1)};
  ${'' /* height: 50px; */}
  line-height: 1.1875rem;
  border-radius: 4px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 0.875rem;
  cursor: pointer;
  font-family: ${props => props.theme.fonts.avenirNextDemi};
  color: ${props =>
    props.isSelected ? props.theme.colors.primary : '#000000'};
  transition: all 0.5s ease;
`

export default Option
